export const TICKET_CREATION_FAILURE = 'TICKET_CREATION_FAILURE';